exports.components = {
  "component---src-components-candidate-page-tsx": () => import("./../../../src/components/CandidatePage.tsx" /* webpackChunkName: "component---src-components-candidate-page-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

